import React, { useState, useEffect, useCallback } from "react";
import Layout from "components/Layout";
import LineChart from "components/LineChart";
import PieChart from "components/PieChart";
import DashboardTable from "components/DashboardTable";
import UpsideArrowIcon from "assets/svg/UpSideArrow";
import { ChartHeader } from "assets/css/global";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertModal from "components/AlertModal";
import { dashboardTableRecords } from "redux/actions/dashboard";
import { BodyContainer } from "styles/pages/global";
import {
  DashboardChartOuterWrapperChart,
  DashboardChartOuterWrapper,
  ChartFilterWrapper,
  OverView,
  Grid,
  DashboardWrapper,
  OverviewContainer,
  ChartWrapper,
} from "styles/pages/dashboard";
import ChartFilters from "./ChartFilters";
import BuybackDetails from "./BuybackDetails";
import { useText } from "locales/useGetText";
const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locale = useText("dashboard");
  const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserData"));
  const [chartFilters, setChartFilter] = useState();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    fetchMyAPI();
  }, []);

  const [response, setResponse] = useState();
  const fetchMyAPI = useCallback(async () => {
    let data = {
      size: 10,
      number: 0,
      sort: "DESC",
    };
    let response = await dispatch(
      dashboardTableRecords(
        data,
        loggedInUserInfo?.locationType,
        loggedInUserInfo?.customerId,
        loggedInUserInfo?.token
      )
    );
    if (response?.data?.success) {
      setResponse(response?.data);
    } else {
      if (response?.data?.error?.message === "Invalid Token") {
        navigate("/");
      } else {
        setModalContent(
          response?.data?.error?.message ||
            response.message ||
           locale('genericErrorLater')
        );
        setModalLink("");
        toggleModal();
      }
    }
  }, []);

  let headerArr = [
    locale('refNo'),
    locale('location'),
    locale('loadDetails'),
    // "Qty",
   locale('date'),
  ];
  let header = [
    locale('refNo'),
    locale('location'),
    locale('loadDetails'),
    // "Qty",
   locale('date'),
    locale('status'),
  ];

  const formFields = () => {
    return (
      <Layout activeTab="Dashboard">
        <DashboardWrapper>
          <OverviewContainer>
            <h6>{locale('overview')}</h6>
            <OverView>
              <Grid>
                <div
                  className="heading-div"
                  onClick={() => {
                    localStorage.setItem("manageOrderTab", 0);
                    navigate("/manage-orders");
                  }}
                >
                  <h4 className="heading">{locale('requestedOrders')}</h4>
                  <p className="order-number">
                    {response?.data?.pendingOrders?.orders} <span>{locale('orders')}</span>
                  </p>
                </div>
                {response?.data?.pendingOrders?.ratio &&
                response?.data?.pendingOrders?.ratio !== 0 &&
                response?.data?.pendingOrders?.ratio !== "NaN" ? (
                  <div className="stats">
                    <h5 className="green">
                      +{response?.data?.pendingOrders?.ratio}+%
                      <UpsideArrowIcon />
                    </h5>
                  </div>
                ) : (
                  ""
                )}
              </Grid>
              <Grid>
                <div
                  className="heading-div"
                  onClick={() => {
                    localStorage.setItem("manageOrderTab", 1);
                    navigate("/manage-orders");
                  }}
                >
                  <h4 className="heading">{locale('pendingOrders')}</h4>
                  <p className="order-number">
                    {response?.data?.assignedOrders?.orders} <span>{locale('orders')}</span>
                  </p>
                </div>
                {response?.data?.assignedOrders?.ratio &&
                response?.data?.assignedOrders?.ratio !== 0 &&
                response?.data?.assignedOrders?.ratio !== "NaN" ? (
                  <div className="stats">
                    <h5 className="green">
                      +{response?.data?.assignedOrders?.ratio}+%
                      <UpsideArrowIcon />
                    </h5>
                  </div>
                ) : (
                  ""
                )}
              </Grid>{" "}
              <Grid>
                <div
                  className="heading-div"
                  onClick={() => {
                    localStorage.setItem("manageOrderTab", 3);
                    navigate("/manage-orders");
                  }}
                >
                  <h4 className="heading">{locale('completedOrders')}</h4>
                  <p className="order-number">
                    {response?.data?.completedOrders?.orders}{" "}
                    <span>{locale('orders')}</span>
                  </p>
                </div>
                {response?.data?.completedOrders?.ratio &&
                response?.data?.completedOrders?.ratio !== 0 &&
                response?.data?.completedOrders?.ratio !== "NaN" ? (
                  <div className="stats">
                    <h5 className="green">
                      +{response?.data?.completedOrders?.ratio}+%
                      <UpsideArrowIcon />
                    </h5>
                  </div>
                ) : (
                  ""
                )}
              </Grid>{" "}
              <Grid>
                <div
                  className="heading-div"
                  onClick={() => {
                    localStorage.setItem("manageOrderTab", 4);
                    navigate("/manage-orders");
                  }}
                >
                  <h4 className="heading">{locale('canceledOrders')}</h4>
                  <p className="order-number">
                    {response?.data?.cancelledOrders?.orders}{" "}
                    <span>{locale('orders')}</span>
                  </p>
                </div>
                {response?.data?.cancelledOrders?.ratio &&
                response?.data?.cancelledOrders?.ratio !== 0 &&
                response?.data?.cancelledOrders?.ratio !== "NaN" ? (
                  <div className="stats">
                    <h5 className="red">
                      -{response?.data?.cancelledOrders?.ratio}+%
                      <UpsideArrowIcon color="red" />
                    </h5>
                  </div>
                ) : (
                  ""
                )}
              </Grid>
            </OverView>
          </OverviewContainer>

          <ChartFilterWrapper>
            <ChartFilters
              locale={locale}
              onChartFilterChange={(filters) => setChartFilter(filters)}
            />
          </ChartFilterWrapper>

          <DashboardChartOuterWrapperChart>
            <ChartWrapper>
              <LineChart chartFilters={chartFilters} locale={locale}/>
            </ChartWrapper>
            <ChartWrapper>
              <PieChart chartFilters={chartFilters} locale={locale}/>
            </ChartWrapper>
            <ChartWrapper>
              <BuybackDetails chartFilters={chartFilters} locale={locale} />
            </ChartWrapper>
          </DashboardChartOuterWrapperChart>

          <DashboardChartOuterWrapper>
            <ChartWrapper>
              <div>
                <ChartHeader>
                  <h4>{locale('upcomingOrders')}</h4>
                </ChartHeader>
                <DashboardTable
                  type="chart"
                  headerArr={header}
                  response={response?.data?.upcomingOrderList?.orders}
                  locale={locale}
                />
              </div>
            </ChartWrapper>
            <ChartWrapper>
              <ChartHeader>
                <h4>{locale('recentlyDeliveredOrders')}</h4>
              </ChartHeader>
              <DashboardTable
                headerArr={headerArr}
                response={response?.data?.recentlyCompletedOrderList?.orders}
                locale={locale}
              />
            </ChartWrapper>
          </DashboardChartOuterWrapper>
        </DashboardWrapper>

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={locale('alert')}
          content={modalContent}
          link={modalLink}
          className="alert-msg-container"
          InnerClassName="alert-msg"
        />
      </Layout>
    );
  };

  return <BodyContainer>{formFields()}</BodyContainer>;
};

export default Dashboard;
